import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=7020b71f&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7020b71f')) {
      api.createRecord('7020b71f', component.options)
    } else {
      api.reload('7020b71f', component.options)
    }
    module.hot.accept("./Full.vue?vue&type=template&id=7020b71f&", function () {
      api.rerender('7020b71f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/Full.vue"
export default component.exports